(function () {
  'use strict';

  if (window.JanelaBayAnalytics && window.JanelaBayAnalytics.version) return;

  var EVENT_PREFIX = 'jb_';
  var VERSION = '1.2.0';
  var MAX_ITEMS = 12;
  var MAX_STRING_LENGTH = 120;
  var contextNode = document.getElementById('janela-bay-analytics-context');
  var context = {};
  var publishQueue = [];
  var pendingQuickAddOpen = null;
  var pendingQuickAddSubmit = null;
  var activeQuickAddContext = null;
  var pendingOptionSelection = null;
  var observedSections = new WeakSet();
  var completedSections = new WeakSet();
  var sectionTimers = new WeakMap();
  var recentEventSignatures = new Map();
  var debugEvents = [];
  var debugEnabled = /(?:^|[?&])_jb_analytics_qa(?:=|&|$)/.test(window.location.search);
  var ga4Configured = false;
  var ga4MeasurementId = '';
  var lastMonsterCartOpen = false;
  var lastCartSnapshot = null;
  var monsterCartRefreshTimer = null;
  var monsterCartPendingOpened = false;
  var monsterCartPendingSource = '';
  var monsterCartViewToken = 0;
  var observedMonsterCart = null;

  if (debugEnabled) {
    try {
      debugEvents = JSON.parse(sessionStorage.getItem('jb_analytics_debug_events') || '[]').slice(-30);
    } catch (error) {
      debugEvents = [];
    }
  }

  try {
    context = contextNode ? JSON.parse(contextNode.textContent || '{}') : {};
  } catch (error) {
    context = {};
  }

  function cleanString(value, maxLength) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || MAX_STRING_LENGTH);
  }

  function cleanPath(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      return url.pathname;
    } catch (error) {
      return cleanString(value, 160).split('?')[0].split('#')[0];
    }
  }

  function cleanDestinationPath(value) {
    var type = destinationType(value);
    return type === 'phone' || type === 'email' ? '' : cleanPath(value);
  }

  function cleanValue(value, depth) {
    if (depth > 3 || value === undefined || value === null) return undefined;
    if (typeof value === 'string') return cleanString(value);
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (typeof value === 'boolean') return value;

    if (Array.isArray(value)) {
      return value
        .slice(0, MAX_ITEMS)
        .map(function (item) { return cleanValue(item, depth + 1); })
        .filter(function (item) { return item !== undefined; });
    }

    if (typeof value === 'object') {
      var output = {};
      Object.keys(value).slice(0, 25).forEach(function (key) {
        var cleaned = cleanValue(value[key], depth + 1);
        if (cleaned !== undefined && cleaned !== '') output[key] = cleaned;
      });
      return output;
    }

    return undefined;
  }

  function commonParameters() {
    return {
      event_schema_version: context.event_schema_version || '1.0',
      page_type: context.page_type || document.documentElement.dataset.template || 'unknown',
      page_template: context.page_template || document.body.className.match(/template-\S+/)?.[0] || 'unknown',
      page_group: context.page_group || 'other',
      page_path: context.page_path || window.location.pathname
    };
  }

  function analyticsProcessingAllowed() {
    var privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;
    try {
      return privacy.analyticsProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function ensureDirectGa4() {
    if (!context.direct_ga4_fallback || !analyticsProcessingAllowed()) return false;
    ga4MeasurementId = cleanString(context.ga4_measurement_id || '', 30);
    if (!/^G-[A-Z0-9]+$/.test(ga4MeasurementId)) return false;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    if (!ga4Configured) {
      var selector = 'script[src*="googletagmanager.com/gtag/js?id=' + ga4MeasurementId + '"]';
      if (!document.querySelector(selector)) {
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ga4MeasurementId);
        document.head.appendChild(script);
      }
      window.gtag('js', new Date());
      window.gtag('config', ga4MeasurementId, { send_page_view: false });
      ga4Configured = true;
    }

    return true;
  }

  function sendDirectGa4(eventName, parameters) {
    if (!ensureDirectGa4()) return false;
    var payload = cleanValue(Object.assign({}, parameters || {}, {
      send_to: ga4MeasurementId,
      event_source: 'jb_theme_fallback',
      event_transport_version: VERSION,
      debug_mode: debugEnabled || undefined
    }), 0) || {};
    try {
      window.gtag('event', eventName, payload);
      return true;
    } catch (error) {
      return false;
    }
  }

  function toGa4Item(item) {
    return {
      item_id: cleanString(item?.item_id || ''),
      item_name: cleanString(item?.item_name || ''),
      item_variant: cleanString(item?.item_variant || ''),
      item_brand: cleanString(item?.item_brand || ''),
      item_category: cleanString(item?.item_category || ''),
      item_list_name: cleanString(item?.item_list_name || ''),
      index: Number(item?.index || item?.item_position || 0) || undefined,
      quantity: Number(item?.quantity || 1) || 1,
      price: Number(item?.price || 0) || undefined
    };
  }

  function sendMappedGa4Event(event) {
    if (event.name === 'jb_product_list_view' && event.data.items?.length) {
      sendDirectGa4('view_item_list', {
        item_list_name: event.data.item_list_name,
        items: event.data.items.map(toGa4Item)
      });
    } else if (event.name === 'jb_product_card_select') {
      sendDirectGa4('select_item', {
        item_list_name: event.data.item_list_name,
        items: [toGa4Item(event.data)]
      });
    }
  }

  function sendToShopify(event) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      return false;
    }

    try {
      window.Shopify.analytics.publish(event.name, event.data);
      return true;
    } catch (error) {
      return false;
    }
  }

  function flushQueue() {
    if (!publishQueue.length) return;
    publishQueue = publishQueue.filter(function (event) {
      return !sendToShopify(event);
    });
  }

  function publish(eventName, parameters) {
    var event = {
      name: EVENT_PREFIX + eventName,
      data: cleanValue(Object.assign({}, commonParameters(), parameters || {}), 0) || {}
    };
    var now = Date.now();
    var signature = event.name + '|' + JSON.stringify(event.data);
    var lastPublishedAt = recentEventSignatures.get(signature) || 0;
    if (now - lastPublishedAt < 400) return;
    recentEventSignatures.set(signature, now);
    if (recentEventSignatures.size > 100) {
      recentEventSignatures.forEach(function (publishedAt, key) {
        if (now - publishedAt > 2000) recentEventSignatures.delete(key);
      });
    }

    debugEvents.push({
      name: event.name,
      data: event.data,
      published_at: new Date().toISOString()
    });
    if (debugEvents.length > 100) debugEvents.shift();
    if (debugEnabled && contextNode) {
      try {
        sessionStorage.setItem('jb_analytics_debug_events', JSON.stringify(debugEvents.slice(-30)));
      } catch (error) {
        // QA receipts still remain available on the current page when storage is unavailable.
      }
      contextNode.setAttribute('data-analytics-events', JSON.stringify(debugEvents.slice(-30)));
    }

    document.dispatchEvent(new CustomEvent('janela-bay:analytics-event', {
      detail: event
    }));

    sendDirectGa4(event.name, event.data);
    sendMappedGa4Event(event);

    if (!sendToShopify(event)) publishQueue.push(event);
  }

  function getSectionRoot(element) {
    return element?.closest?.('[id^="shopify-section-"]') || element?.closest?.('section') || null;
  }

  function getSectionPosition(section) {
    if (!section) return 0;
    var siblings = Array.from(document.querySelectorAll('#MainContent > [id^="shopify-section-"]'));
    var index = siblings.indexOf(section);
    return index >= 0 ? index + 1 : 0;
  }

  function getSectionName(section) {
    if (!section) return '';
    var explicitName = section.querySelector('[data-analytics-section-name]')?.dataset.analyticsSectionName;
    if (explicitName) return cleanString(explicitName);

    var heading = section.querySelector('h1, h2, .m-section__heading, .hp-heading, h3');
    return cleanString(heading?.textContent || section.dataset.sectionType || section.id || 'Untitled section');
  }

  function getSectionType(section) {
    if (!section) return 'unknown';
    var typedElement = section.matches('[data-section-type]')
      ? section
      : section.querySelector('[data-section-type]');
    var explicitType = typedElement?.dataset.sectionType;
    var signature = [
      explicitType,
      section.id,
      section.className,
      getSectionName(section)
    ].join(' ').toLowerCase();

    if (
      section.querySelector('.handpicked-row') ||
      signature.includes('collection-template') ||
      signature.includes('search-template') ||
      (context.page_group === 'search_results' && section.querySelector('.m-product-card, [data-view="card"]'))
    ) {
      return 'product_list';
    }
    // The primary product section can contain a review badge/widget. Classify it
    // as product information before checking review markup so standard view_item
    // remains the authoritative product-view signal.
    if (signature.includes('main-product') || section.querySelector('.m-main-product')) return 'product_info';
    if (
      signature.includes('review') ||
      section.querySelector(
        '#judgeme_product_reviews, .jdgm-review-widget, .jm-review-widget, [aria-label="Customer reviews"], [class*="judgeme"], [class*="jm-review"], [class*="jdgm-"]'
      )
    ) {
      return 'reviews';
    }
    if (signature.includes('faq')) return 'faq';
    if (signature.includes('find-a-store') || signature.includes('store-locator') || section.querySelector('.jb-store-directory')) {
      return 'store_locator';
    }
    if (
      signature.includes('slideshow') ||
      signature.includes('announcement') ||
      signature.includes('promotion') ||
      (signature.includes('slider') && !section.querySelector('.m-product-card, [data-view="card"]'))
    ) {
      return 'promotion';
    }
    if (explicitType) return cleanString(explicitType.toLowerCase().replace(/\s+/g, '_'), 60);

    var className = cleanString(section.className, 100).split(' ').filter(function (name) {
      return name && name !== 'shopify-section' && name !== 'section';
    })[0];
    var derivedType = className ? className.replace(/^shopify-section-?/, '').replace(/[^a-z0-9_-]/gi, '_').toLowerCase() : '';
    return derivedType || 'content';
  }

  function getSectionParameters(element) {
    var section = getSectionRoot(element);
    return {
      section_type: getSectionType(section),
      section_name: getSectionName(section),
      section_position: getSectionPosition(section)
    };
  }

  function getSelectedOption(card, typePattern) {
    if (!card) return '';
    var selected = card.querySelector(
      '[data-option-type*="' + typePattern + '" i][data-selected="true"], ' +
      '[data-option-name*="' + typePattern + '" i] input:checked, ' +
      '[data-option-name*="' + typePattern + '" i] option:checked, ' +
      '.m-product-option--node.active[data-value], ' +
      '.m-product-option--node input:checked'
    );
    return cleanString(selected?.value || selected?.dataset?.value || selected?.textContent || '');
  }

  function getProductCard(element) {
    return element?.closest?.('.m-product-card, [data-view="card"], [data-product-card-swatch-scope]') || null;
  }

  function getListRoot(card) {
    return card?.closest?.(
      '.handpicked-row, [data-section-type="collection-template"], [data-section-type="search-template"], [data-product-container], [id^="shopify-section-"]'
    ) || getSectionRoot(card);
  }

  function getItemListName(listRoot) {
    var section = getSectionRoot(listRoot) || listRoot;
    if (context.page_group === 'search_results') return 'Search results';
    if (listRoot?.matches?.('[data-section-type="collection-template"]') || context.page_group === 'collection_listing') {
      return context.collection_name || getSectionName(section) || 'Collection results';
    }
    return getSectionName(section) || 'Product recommendations';
  }

  function getCardPosition(card, listRoot) {
    if (!card || !listRoot) return 0;
    var cards = Array.from(listRoot.querySelectorAll('.m-product-card, [data-view="card"]'));
    var uniqueCards = cards.filter(function (candidate, index) {
      return cards.indexOf(candidate) === index;
    });
    var index = uniqueCards.indexOf(card);
    return index >= 0 ? index + 1 : 0;
  }

  function getProductData(card, listRoot) {
    if (!card) return {};
    var titleLink = card.querySelector('.m-product-card__name, .m-product-card__title a, .m-product-card__link');
    var variantInput = card.querySelector('[name="id"]');
    var variantId = card.dataset.variantId || variantInput?.value || '';
    var productName = cleanString(
      card.querySelector('.m-product-card__name')?.textContent ||
      titleLink?.getAttribute('aria-label') ||
      titleLink?.textContent
    );

    return {
      item_id: cleanString(card.dataset.productId || ''),
      item_name: productName,
      item_variant: cleanString(variantId),
      product_handle: cleanPath(titleLink?.href || '').split('/products/')[1] || card.dataset.productHandle || '',
      selected_color: getSelectedOption(card, 'color'),
      selected_size: getSelectedOption(card, 'size'),
      item_list_name: getItemListName(listRoot),
      item_position: getCardPosition(card, listRoot),
      index: getCardPosition(card, listRoot)
    };
  }

  function getProductItems(section) {
    var cards = Array.from(section.querySelectorAll('.m-product-card, [data-view="card"]'));
    var uniqueCards = cards.filter(function (card, index) {
      return cards.indexOf(card) === index;
    });
    var visibleCards = uniqueCards.filter(function (card) {
      return card.offsetParent !== null && card.getClientRects().length > 0;
    });
    var listCards = visibleCards.length ? visibleCards : uniqueCards;

    return listCards.slice(0, MAX_ITEMS).map(function (card) {
      return getProductData(card, section);
    });
  }

  function getVisibleProductCardCount(root) {
    if (!root) return 0;
    var cards = Array.from(root.querySelectorAll('.m-product-card, [data-view="card"]'));
    var uniqueCards = cards.filter(function (card, index) {
      return cards.indexOf(card) === index;
    });
    return uniqueCards.filter(function (card) {
      return card.offsetParent !== null && card.getClientRects().length > 0;
    }).length;
  }

  function resultsCountBucket(count) {
    if (!count) return '0';
    if (count <= 4) return '1_4';
    if (count <= 12) return '5_12';
    if (count <= 24) return '13_24';
    return '25_plus';
  }

  function availabilityState(variant) {
    if (!variant || !variant.id) return 'unavailable';
    return variant.available ? 'available' : 'sold_out';
  }

  function getPickerSelectedOption(picker, typePattern) {
    if (!picker) return '';
    var pattern = new RegExp(typePattern, 'i');
    var selected = Array.from(picker.querySelectorAll('input:checked, option:checked')).find(function (input) {
      var field = input.closest('[data-option-name], fieldset, .m-product-option') || input.parentElement;
      var identifier = [input.name, field?.dataset?.optionName, field?.dataset?.optionType, field?.textContent].join(' ');
      return pattern.test(identifier);
    });
    return cleanString(selected?.value || selected?.textContent || '');
  }

  function getProductAvailabilityParameters(variant, source) {
    var picker = document.querySelector('#MainContent product-info variant-picker') || document.querySelector('product-info variant-picker');
    var selectedColor = getPickerSelectedOption(picker, 'color');
    var selectedSize = getPickerSelectedOption(picker, 'size|age');
    var base = activeQuickAddContext || {};

    return Object.assign({}, getSectionParameters(picker || document.querySelector('#MainContent product-info')), {
      item_id: cleanString(base.item_id || context.product_id || ''),
      item_name: cleanString(base.item_name || context.product_name || ''),
      item_variant: cleanString(variant?.id || ''),
      product_handle: cleanString(base.product_handle || context.product_handle || ''),
      selected_color: cleanString(selectedColor),
      selected_size: cleanString(selectedSize),
      availability_state: availabilityState(variant),
      interaction_source: source || 'product_page'
    });
  }

  function isReviewArea(element) {
    return Boolean(element?.closest?.(
      '#judgeme_product_reviews, .jdgm-widget, .jdgm-review-widget, .jm-review-widget, [class*="judgeme"]'
    ));
  }

  function isStoreArea(element) {
    return Boolean(element?.closest?.(
      '.m-find-store, .jb-store-card, .jb-store-directory, .jb-store-locator-map, [data-section-type="find-a-store"]'
    ));
  }

  function isPromotionSection(section) {
    return getSectionType(section) === 'promotion';
  }

  function destinationType(href) {
    if (!href) return 'button';
    if (href.charAt(0) === '#') return 'anchor';
    if (href.indexOf('tel:') === 0) return 'phone';
    if (href.indexOf('mailto:') === 0) return 'email';
    try {
      return new URL(href, window.location.origin).origin === window.location.origin ? 'internal' : 'external';
    } catch (error) {
      return 'other';
    }
  }

  function trackProductCardSelection(link) {
    var card = getProductCard(link);
    if (!card) return;
    var listRoot = getListRoot(card);
    publish('product_card_select', Object.assign(
      {},
      getSectionParameters(card),
      getProductData(card, listRoot),
      {
        interaction_source: context.page_group === 'search_results' ? 'search_results' : 'product_list',
        destination_path: cleanDestinationPath(link.href)
      }
    ));
  }

  function trackQuickAddClick(button) {
    var card = getProductCard(button);
    pendingQuickAddOpen = Object.assign(
      {},
      getSectionParameters(button),
      getProductData(card, getListRoot(card)),
      {
        interaction_source: 'product_card'
      }
    );
    activeQuickAddContext = pendingQuickAddOpen;
  }

  function getQuickAddSubmitContext(form) {
    var card = getProductCard(form);
    var quickView = form.closest('#MainProduct-quick-view__content, .m-modal');
    if (!card && !quickView) return null;

    var productInfo = form.closest('product-info');
    var variantId = form.querySelector('[name="id"]')?.value || '';
    var payload = card
      ? getProductData(card, getListRoot(card))
      : activeQuickAddContext
        ? Object.assign({}, activeQuickAddContext, {
          item_variant: cleanString(variantId || activeQuickAddContext.item_variant || '')
        })
        : {
          item_id: cleanString(productInfo?.dataset.productId || ''),
          item_name: cleanString(
            quickView?.querySelector('.m-product-title, h1, h2')?.textContent ||
            context.product_name ||
            ''
          ),
          item_variant: cleanString(variantId)
        };

    return Object.assign({}, getSectionParameters(form), payload, {
      interaction_source: quickView ? 'quick_add_modal' : 'product_card'
    });
  }

  function trackOptionSelection(target) {
    var picker = target.closest('variant-picker');
    if (!picker) return;
    var field = target.closest('[data-option-name]');
    var productInfo = picker.closest('product-info');
    var isQuickAdd = Boolean(picker.closest('#MainProduct-quick-view__content, .m-modal'));
    var sectionParameters = isQuickAdd && activeQuickAddContext
      ? {
        section_type: activeQuickAddContext.section_type,
        section_name: activeQuickAddContext.section_name,
        section_position: activeQuickAddContext.section_position,
        item_list_name: activeQuickAddContext.item_list_name,
        item_position: activeQuickAddContext.item_position,
        index: activeQuickAddContext.index
      }
      : getSectionParameters(target);
    var selectedValue = target.tagName === 'SELECT'
      ? target.selectedOptions?.[0]?.textContent
      : target.value || target.closest('[data-value]')?.dataset.value;

    pendingOptionSelection = Object.assign({}, sectionParameters, {
      item_id: cleanString(productInfo?.dataset.productId || context.product_id || ''),
      item_name: cleanString(
        productInfo?.querySelector('.m-product-title, h1, h2')?.textContent ||
        context.product_name ||
        ''
      ),
      option_name: cleanString(field?.dataset.optionName || target.name || ''),
      option_value: cleanString(selectedValue || ''),
      interaction_source: isQuickAdd ? 'quick_add_modal' : 'product_page'
    });
  }

  function trackItemListPageChange(control) {
    var row = control.closest('.handpicked-row');
    var collectionPagination = control.closest('.m-collection--pagination');
    var action = control.matches('[data-next], .next a') ? 'next'
      : control.matches('[data-prev], .prev a') ? 'previous'
      : control.matches('[data-load-more]') ? 'load_more'
      : 'page_select';
    var page = 0;

    if (row) {
      var currentPage = Number(row.dataset.analyticsPage || '1');
      if (action === 'next' || action === 'load_more') page = currentPage + 1;
      else if (action === 'previous') page = Math.max(1, currentPage - 1);
      else page = currentPage;
      row.dataset.analyticsPage = String(page);
    } else if (collectionPagination && control.href) {
      var url = new URL(control.href, window.location.origin);
      page = Number(url.searchParams.get('page') || url.searchParams.get('jb_page') || cleanString(control.textContent)) || 1;
    }

    publish('item_list_page_change', Object.assign({}, getSectionParameters(control), {
      interaction_action: action,
      item_list_name: getItemListName(row || collectionPagination),
      item_list_page: page
    }));
  }

  function filterLabel(element) {
    var widget = element.closest('.m-filter--widget, .m-accordion--item, fieldset');
    return cleanString(
      widget?.querySelector('.m-filter--widget-title, .m-accordion--item-button, legend')?.textContent ||
      element.name ||
      ''
    );
  }

  function trackFilterChange(target) {
    if (!target.name || target.name.indexOf('filter.') !== 0) return;
    var isRemoval = (target.type === 'checkbox' || target.type === 'radio') && !target.checked;
    publish(isRemoval ? 'collection_filter_remove' : 'collection_filter_apply', Object.assign(
      {},
      getSectionParameters(target),
      {
        filter_name: filterLabel(target),
        filter_value: cleanString(target.value || ''),
        interaction_source: 'collection_filters'
      }
    ));
  }

  function trackFilterRemoval(link) {
    var url = new URL(link.href, window.location.origin);
    publish('collection_filter_remove', Object.assign({}, getSectionParameters(link), {
      filter_name: cleanString(link.textContent || 'active_filter'),
      filter_value: '',
      interaction_source: 'active_filter'
    }));
  }

  function trackSortChange(element, value) {
    publish('collection_sort_change', Object.assign({}, getSectionParameters(element), {
      sort_value: cleanString(value || ''),
      interaction_source: 'collection_sort'
    }));
  }

  function trackFilterResultsUpdate() {
    if (context.page_group !== 'collection_listing') return;
    var collectionRoot = document.querySelector('#MainContent [data-section-type="collection-template"], #MainContent .m-collection--products, #MainContent .m-collection');
    var resultCount = getVisibleProductCardCount(collectionRoot || document.getElementById('MainContent'));
    var activeFilters = document.querySelectorAll('input[name^="filter."]:checked, .m-active-facets a, [data-remove-filter]').length;

    publish('filter_results_update', Object.assign({}, getSectionParameters(collectionRoot), {
      results_count: resultCount,
      results_count_bucket: resultsCountBucket(resultCount),
      active_filter_count: activeFilters,
      interaction_source: 'collection_filters'
    }));
  }

  function trackContentExpand(control) {
    var section = getSectionRoot(control);
    var sectionType = getSectionType(section);
    var itemTitle = cleanString(control.textContent);
    var willOpen = true;

    if (control.tagName === 'SUMMARY') {
      willOpen = !control.closest('details')?.open;
    } else {
      var item = control.closest('.m-collapsible, .m-accordion--item');
      var content = item?.querySelector('[data-content], .m-collapsible--content, .m-accordion--item-content');
      willOpen = Boolean(content?.hidden || !item?.classList.contains('open'));
    }

    if (!willOpen) return;
    publish('content_expand', Object.assign({}, getSectionParameters(control), {
      content_type: sectionType === 'faq' ? 'faq' : 'product_details',
      item_title: itemTitle,
      interaction_action: 'open'
    }));
  }

  function trackReviewInteraction(element) {
    var control = element.closest('button, a, [role="button"], [role="tab"]');
    if (!control) return;
    var signature = (control.className + ' ' + control.textContent + ' ' + (control.getAttribute('aria-label') || '')).toLowerCase();
    var action = signature.includes('write') || signature.includes('feedback') ? 'write_review'
      : signature.includes('next') || signature.includes('prev') || signature.includes('arrow') ? 'page_change'
      : signature.includes('filter') || signature.includes('star') ? 'filter'
      : signature.includes('more') || signature.includes('read') ? 'expand_review'
      : 'review_control';

    publish('review_interaction', Object.assign({}, getSectionParameters(control), {
      interaction_action: action,
      interaction_source: 'reviews'
    }));
  }

  function trackProductMediaInteraction(element) {
    var control = element.closest(
      'media-gallery .swiper-button-prev, media-gallery .swiper-button-next, media-gallery .m-product-media__zoom-in, media-gallery [data-media-id], media-gallery [class*="thumbnail"]'
    );
    if (!control) return;
    var signature = (control.className + ' ' + (control.getAttribute('aria-label') || '')).toLowerCase();
    var action = signature.includes('next') ? 'next'
      : signature.includes('prev') ? 'previous'
      : signature.includes('zoom') ? 'zoom'
      : 'thumbnail_select';

    publish('product_media_interaction', Object.assign({}, getSectionParameters(control), {
      interaction_action: action,
      media_id: cleanString(control.dataset.mediaId || control.closest('[data-media-id]')?.dataset.mediaId || ''),
      interaction_source: 'product_gallery'
    }));
  }

  function trackStoreInteraction(element) {
    var link = element.closest('a, button');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var card = link.closest('.jb-store-card');
    var action = href.indexOf('tel:') === 0 ? 'phone'
      : /maps|g\.page|goo\.gl/i.test(href) ? 'directions'
      : /inventory|availability/i.test(link.textContent + ' ' + href) ? 'inventory_check'
      : href ? 'store_page' : 'open';

    publish('store_locator_interaction', Object.assign({}, getSectionParameters(link), {
      interaction_action: action,
      store_name: cleanString(card?.querySelector('.jb-store-card__title')?.textContent || ''),
      destination_type: destinationType(href),
      destination_path: cleanDestinationPath(href),
      interaction_source: 'store_locator'
    }));
  }

  function trackPromotionSelect(element) {
    var link = element.closest('a[href], [data-promotion-link]');
    if (!link) return;
    var creativeName = cleanString(link.textContent || link.getAttribute('aria-label') || '');
    publish('promotion_select', Object.assign({}, getSectionParameters(link), {
      promotion_name: creativeName || getSectionName(getSectionRoot(link)),
      creative_name: creativeName,
      destination_path: cleanDestinationPath(link.getAttribute('href') || ''),
      interaction_source: 'promotion'
    }));
  }

  function getCartRoot() {
    return document.querySelector('#monster-cart-wrapper, m-cart-drawer, m-cart, .m-cart-drawer, .m-cart');
  }

  function getCartItemCount(cart) {
    if (typeof cart?.item_count === 'number') return cart.item_count;
    var badge = document.querySelector('m-cart-count');
    return Number(cleanString(badge?.textContent || '')) || 0;
  }

  function publishCartUpdate(action, cart, source) {
    publish('cart_update', Object.assign({}, getSectionParameters(getCartRoot()), {
      interaction_action: action || 'update',
      cart_item_count: getCartItemCount(cart),
      interaction_source: source || 'cart'
    }));
  }

  function publishCartDrawerView(source, cart) {
    var drawer = document.querySelector('#monster-cart-wrapper.mu_openned, m-cart-drawer, .m-cart-drawer');
    if (!drawer) return;
    publish('cart_drawer_view', Object.assign({}, getSectionParameters(drawer), {
      cart_item_count: getCartItemCount(cart),
      interaction_source: source || 'cart_drawer'
    }));
  }

  function cartEndpoint() {
    var root = window.Shopify?.routes?.root || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function loadCartSnapshot() {
    return window.fetch(cartEndpoint(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_snapshot_failed');
      return response.json();
    }).then(function (cart) {
      return {
        item_count: Number(cart.item_count || 0),
        total_price: Number(cart.total_price || 0) / 100,
        currency: cleanString(cart.currency || context.currency || 'USD', 10),
        items: (cart.items || []).slice(0, MAX_ITEMS).map(function (item) {
          return {
            key: cleanString(item.key || item.variant_id || '', 100),
            item_id: 'shopify_US_' + cleanString(item.product_id || '') + '_' + cleanString(item.variant_id || ''),
            item_name: cleanString(item.product_title || item.title || ''),
            item_variant: cleanString(item.variant_title || ''),
            item_category: cleanString(item.product_type || ''),
            item_brand: cleanString(item.vendor || ''),
            price: Number(item.final_price || item.price || 0) / 100,
            quantity: Number(item.quantity || 0)
          };
        })
      };
    });
  }

  function cartSnapshotSignature(snapshot) {
    if (!snapshot) return '';
    return JSON.stringify(snapshot.items.map(function (item) {
      return [item.key, item.quantity, item.price];
    }));
  }

  function removedCartItems(before, after) {
    if (!before) return [];
    var afterQuantities = new Map();
    (after?.items || []).forEach(function (item) {
      afterQuantities.set(item.key, item.quantity);
    });
    return before.items.reduce(function (removed, item) {
      var quantityRemoved = item.quantity - (afterQuantities.get(item.key) || 0);
      if (quantityRemoved > 0) removed.push(Object.assign({}, item, { quantity: quantityRemoved }));
      return removed;
    }, []);
  }

  function sendGa4CartView(snapshot, source) {
    if (!snapshot.items.length) return;
    sendDirectGa4('view_cart', {
      currency: snapshot.currency,
      value: snapshot.total_price,
      items: snapshot.items.map(toGa4Item),
      interaction_source: source || 'monster_cart'
    });
  }

  function publishMonsterCartViewWhenReady(source) {
    var token = ++monsterCartViewToken;

    function check(attempt) {
      loadCartSnapshot().then(function (snapshot) {
        if (token !== monsterCartViewToken) return;
        var drawerOpen = Boolean(document.querySelector('#monster-cart-wrapper.mu_openned'));
        if (!snapshot.items.length && drawerOpen && attempt < 4) {
          window.setTimeout(function () { check(attempt + 1); }, 400);
          return;
        }
        publishCartDrawerView(source || 'monster_cart', snapshot);
        sendGa4CartView(snapshot, source || 'monster_cart');
      }).catch(function () {
        publishCartDrawerView(source || 'monster_cart');
      });
    }

    check(0);
  }

  function refreshMonsterCart(source, cartOpened) {
    monsterCartPendingOpened = monsterCartPendingOpened || Boolean(cartOpened);
    if (cartOpened || !monsterCartPendingSource) monsterCartPendingSource = source || 'monster_cart';
    window.clearTimeout(monsterCartRefreshTimer);
    monsterCartRefreshTimer = window.setTimeout(function () {
      var shouldRecordView = monsterCartPendingOpened;
      var viewSource = monsterCartPendingSource || source || 'monster_cart';
      monsterCartPendingOpened = false;
      monsterCartPendingSource = '';
      loadCartSnapshot().then(function (snapshot) {
        var previous = lastCartSnapshot;
        var changed = cartSnapshotSignature(previous) !== cartSnapshotSignature(snapshot);
        var removed = removedCartItems(previous, snapshot);

        if (shouldRecordView) {
          publishMonsterCartViewWhenReady(viewSource);
        } else if (changed && previous) {
          publish('cart_update', Object.assign({}, getSectionParameters(getCartRoot()), {
            interaction_action: removed.length ? 'remove_or_decrease_confirmed' : 'cart_change_confirmed',
            cart_item_count: snapshot.item_count,
            interaction_source: source || 'monster_cart'
          }));
          if (removed.length) {
            sendDirectGa4('remove_from_cart', {
              currency: snapshot.currency,
              value: removed.reduce(function (total, item) { return total + item.price * item.quantity; }, 0),
              items: removed.map(toGa4Item),
              interaction_source: source || 'monster_cart'
            });
          }
        }

        lastCartSnapshot = snapshot;
      }).catch(function () {
        publish('cart_tracking_error', {
          error_category: 'cart_snapshot_unavailable',
          interaction_source: source || 'monster_cart'
        });
      });
    }, 250);
  }

  function observeMonsterCart(root) {
    if (!root || observedMonsterCart === root) return;
    observedMonsterCart = root;
    lastMonsterCartOpen = root.classList.contains('mu_openned');

    var observer = new MutationObserver(function () {
      var isOpen = root.classList.contains('mu_openned');
      if (isOpen && !lastMonsterCartOpen) {
        refreshMonsterCart('monster_cart', true);
      } else if (isOpen) {
        refreshMonsterCart('monster_cart_update', false);
      }
      lastMonsterCartOpen = isOpen;
    });
    observer.observe(root, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  function initMonsterCartTracking() {
    var existingRoot = document.getElementById('monster-cart-wrapper');
    observeMonsterCart(existingRoot);
    if (existingRoot) return;

    var bodyObserver = new MutationObserver(function () {
      var root = document.getElementById('monster-cart-wrapper');
      if (!root) return;
      observeMonsterCart(root);
      bodyObserver.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function publishAppliedPromotion(source) {
    var cartRoot = getCartRoot();
    if (!cartRoot || !cartRoot.querySelector('.m-cart__discount, [data-minimog-cart-discounts] li')) return;

    publish('promotion_qualification', Object.assign({}, getSectionParameters(cartRoot), {
      qualification_state: 'qualified',
      qualification_source: 'applied_cart_discount',
      interaction_source: source || 'cart'
    }));
  }

  function trackCartControl(control) {
    var cartRoot = control.closest('#monster-cart-wrapper, m-cart-drawer, m-cart, .m-cart-drawer, .m-cart');
    if (!cartRoot) return false;

    if (control.closest('.mu-remove-item, .m-cart-item__remove, [data-cart-item-remove], [data-remove]')) {
      publishCartUpdate('remove_item_select', null, 'cart');
      return true;
    }

    if (control.closest('[aria-label*="item quantity" i], [data-quantity-minus], [data-quantity-plus], .m-quantity-input__button, [data-quantity-input]')) {
      publishCartUpdate('quantity_change_select', null, 'cart');
      return true;
    }

    return false;
  }

  function trackCartDrawerTrigger(trigger) {
    if (!trigger) return false;
    var href = trigger.getAttribute('href') || '';
    var isCartTrigger = trigger.matches(
      '.m-cart-icon-bubble, [data-cart-drawer-open], [aria-controls*="Cart" i], [aria-label*="cart" i], a[href$="/cart"], a[href*="/cart?"]'
    );
    if (/close|back/i.test(trigger.getAttribute('aria-label') || '')) return false;
    if (!isCartTrigger || (!href && trigger.tagName === 'A')) return false;

    publishCartDrawerView('cart_navigation');
    publishAppliedPromotion('cart_navigation');
    return true;
  }

  function trackCtaClick(element) {
    var control = element.closest('a.m-button, button.m-button, .m-button a');
    if (!control || control.closest('header, footer, .m-product-card, .m-pagination, .hp-pager, .m-modal')) return;
    if (isReviewArea(control) || isStoreArea(control) || isPromotionSection(getSectionRoot(control))) return;
    if (control.matches('.m-product-quickview-button, .m-add-to-cart') || control.closest('product-form')) return;

    var href = control.getAttribute('href') || control.closest('a')?.getAttribute('href') || '';
    publish('cta_click', Object.assign({}, getSectionParameters(control), {
      cta_text: cleanString(control.textContent || control.getAttribute('aria-label') || ''),
      destination_type: destinationType(href),
      destination_path: cleanDestinationPath(href),
      interaction_source: 'page_content'
    }));
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var cartControl = target.closest('button, a, input, [role="button"]');
    var checkoutControl = target.closest('.mu-checkout-btn, [name="checkout"], a[href*="/checkout"]');
    if (checkoutControl) {
      publish('checkout_intent', Object.assign({}, getSectionParameters(checkoutControl), {
        cart_item_count: getCartItemCount(),
        interaction_source: checkoutControl.closest('#monster-cart-wrapper') ? 'monster_cart' : 'cart'
      }));
    }
    if (cartControl && trackCartControl(cartControl)) return;
    if (cartControl && trackCartDrawerTrigger(cartControl)) return;

    var productLink = target.closest('.m-product-card__link, .m-product-card__name');
    if (productLink) {
      trackProductCardSelection(productLink);
      return;
    }

    var quickAddButton = target.closest('.m-product-quickview-button');
    if (quickAddButton) {
      trackQuickAddClick(quickAddButton);
      return;
    }

    var paginationControl = target.closest(
      '.handpicked-row [data-next], .handpicked-row [data-prev], .handpicked-row [data-load-more], .m-collection--pagination a'
    );
    if (paginationControl) {
      trackItemListPageChange(paginationControl);
      return;
    }

    var sortOption = target.closest('.m-select-custom--option[data-value], .m-sort-sheet--item[data-value]');
    if (sortOption) {
      trackSortChange(sortOption, sortOption.dataset.value);
      return;
    }

    var removeFilterLink = target.closest('facet-remove a, .m-active-facets a, [data-remove-filter]');
    if (removeFilterLink) {
      trackFilterRemoval(removeFilterLink);
      return;
    }

    var sizeGuide = target.closest('[data-open-sizechart], [data-open-sizeguide], .size-chart-button');
    if (sizeGuide) {
      publish('size_guide_open', Object.assign({}, getSectionParameters(sizeGuide), {
        interaction_source: sizeGuide.closest('#MainProduct-quick-view__content, .m-modal') ? 'quick_add_modal' : 'product_page'
      }));
      return;
    }

    var expandable = target.closest('.m-collapsible--button[data-trigger], .m-accordion--item-button[data-trigger], details > summary');
    if (expandable) {
      trackContentExpand(expandable);
      return;
    }

    if (isReviewArea(target)) {
      trackReviewInteraction(target);
      return;
    }

    if (target.closest('media-gallery')) {
      trackProductMediaInteraction(target);
      return;
    }

    if (isStoreArea(target)) {
      trackStoreInteraction(target);
      return;
    }

    var section = getSectionRoot(target);
    if (section && isPromotionSection(section)) {
      trackPromotionSelect(target);
      return;
    }

    trackCtaClick(target);
  }

  function onDocumentChange(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('variant-picker')) {
      trackOptionSelection(target);
      return;
    }

    if (target.matches('select[name="sort_by"]')) {
      trackSortChange(target, target.value);
      return;
    }

    trackFilterChange(target);
  }

  function onDocumentSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var productForm = form.closest('product-form');
    if (!productForm) return;
    pendingQuickAddSubmit = getQuickAddSubmitContext(productForm);
  }

  function sectionQualifies(section) {
    if (!section || completedSections.has(section)) return false;
    var rect = section.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    return Boolean(getSectionName(section) || section.querySelector('.m-product-card, [data-section-type], .jdgm-widget'));
  }

  function publishSectionView(section) {
    if (!sectionQualifies(section)) return;
    completedSections.add(section);

    var sectionData = getSectionParameters(section);
    var items = getProductItems(section);

    if (items.length) {
      publish('product_list_view', Object.assign({}, sectionData, {
        item_list_name: getItemListName(section),
        item_count: items.length,
        items: items
      }));
      return;
    }

    if (sectionData.section_type === 'product_info') return;

    if (sectionData.section_type === 'promotion') {
      publish('promotion_view', Object.assign({}, sectionData, {
        promotion_name: sectionData.section_name,
        creative_name: sectionData.section_name
      }));
      return;
    }

    publish('content_section_view', sectionData);
  }

  function initSectionObserver() {
    if (!('IntersectionObserver' in window)) return;

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;
        var existingTimer = sectionTimers.get(section);

        if (entry.isIntersecting) {
          if (existingTimer || completedSections.has(section)) return;
          var timer = window.setTimeout(function () {
            sectionTimers.delete(section);
            publishSectionView(section);
          }, 1000);
          sectionTimers.set(section, timer);
        } else if (existingTimer) {
          window.clearTimeout(existingTimer);
          sectionTimers.delete(section);
        }
      });
    }, {
      rootMargin: '-25% 0px -25% 0px',
      threshold: 0
    });

    Array.from(document.querySelectorAll('#MainContent > [id^="shopify-section-"]')).forEach(function (section) {
      if (observedSections.has(section)) return;
      observedSections.add(section);
      sectionObserver.observe(section);
    });
  }

  function publishFormComplete(formType, source) {
    publish('form_complete', {
      form_type: formType,
      completion_status: 'success',
      interaction_source: source || 'form'
    });
  }

  function initFormCompletions() {
    var params = new URLSearchParams(window.location.search);
    var completionKey = '';
    var formType = '';

    if (params.get('contact_posted') === 'true') {
      completionKey = window.location.pathname + '|contact_posted';
      formType = 'contact';
    } else if (params.get('customer_posted') === 'true' || document.querySelector('[data-email-success="true"]')) {
      completionKey = window.location.pathname + '|email_signup';
      formType = 'email_signup';
    }

    if (completionKey && formType) {
      var lastCompletion = 0;
      try {
        lastCompletion = Number(sessionStorage.getItem('jb_analytics_' + completionKey) || '0');
      } catch (error) {
        lastCompletion = 0;
      }
      if (Date.now() - lastCompletion > 10 * 60 * 1000) {
        try {
          sessionStorage.setItem('jb_analytics_' + completionKey, String(Date.now()));
        } catch (error) {
          // Storage can be unavailable in strict privacy modes; the event still remains valid.
        }
        publishFormComplete(formType, 'shopify_form');
      }
    }

    document.addEventListener('janela-bay:form-success', function (event) {
      publishFormComplete(cleanString(event.detail?.formType || 'form'), cleanString(event.detail?.source || 'custom_form'));
    });
  }

  function initSearchNoResults() {
    if (context.page_group !== 'search_results') return;
    var resultCount = getVisibleProductCardCount(document.getElementById('MainContent'));
    publish('search_results_view', {
      results_count: resultCount,
      results_count_bucket: resultsCountBucket(resultCount),
      interaction_source: 'search_results'
    });
    if (resultCount === 0) {
      publish('search_no_results', {
        results_count: 0,
        interaction_source: 'search_results'
      });
    }
  }

  function initPromotionQualificationTracking() {
    document.addEventListener('janela-bay:promotion-qualification', function (event) {
      var detail = event.detail || {};
      publish('promotion_qualification', Object.assign({}, getSectionParameters(getCartRoot()), {
        qualification_state: cleanString(detail.qualification_state || 'qualified', 40),
        qualification_source: cleanString(detail.qualification_source || 'promotion_component', 60),
        interaction_source: cleanString(detail.interaction_source || 'promotion_component', 60)
      }));
    });

    document.addEventListener('janela-bay:promotion-qualification-error', function (event) {
      var detail = event.detail || {};
      publish('promotion_qualification_error', Object.assign({}, getSectionParameters(getCartRoot()), {
        qualification_state: 'not_qualified',
        error_category: cleanString(detail.error_category || 'unknown', 60),
        interaction_source: cleanString(detail.interaction_source || 'promotion_component', 60)
      }));
    });
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('change', onDocumentChange, true);
  document.addEventListener('submit', onDocumentSubmit, true);

  document.addEventListener('quick-view:loaded', function () {
    if (!pendingQuickAddOpen) return;
    publish('quick_add_open', pendingQuickAddOpen);
    pendingQuickAddOpen = null;
  });

  document.addEventListener('product-ajax:added', function (event) {
    if (pendingQuickAddSubmit) {
      publish('quick_add_complete', Object.assign({}, pendingQuickAddSubmit, {
        item_variant: cleanString(event.detail?.product?.variant_id || pendingQuickAddSubmit.item_variant || ''),
        completion_status: 'success'
      }));
      pendingQuickAddSubmit = null;
      activeQuickAddContext = null;
    }
    publishCartUpdate('add_item', event.detail?.product, 'ajax_cart');
    window.setTimeout(function () {
      publishCartDrawerView('quick_add');
      publishAppliedPromotion('quick_add');
    }, 100);
  });

  document.addEventListener('product-ajax:error', function () {
    if (!pendingQuickAddSubmit) return;
    publish('quick_add_error', Object.assign({}, pendingQuickAddSubmit, {
      completion_status: 'error',
      error_code: 'cart_add_failed'
    }));
    pendingQuickAddSubmit = null;
    activeQuickAddContext = null;
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail?.variant;
    var selectionContext = pendingOptionSelection;
    if (selectionContext) {
      publish('product_option_select', Object.assign({}, selectionContext, {
        item_variant: cleanString(variant?.id || ''),
        selected_color: /colou?r/i.test(selectionContext.option_name) ? selectionContext.option_value : '',
        selected_size: /size|age/i.test(selectionContext.option_name) ? selectionContext.option_value : ''
      }));
    }
    publish('product_availability_state', getProductAvailabilityParameters(variant, selectionContext?.interaction_source));
    pendingOptionSelection = null;
  });

  document.addEventListener('collection:rerendered', function () {
    initSectionObserver();
    trackFilterResultsUpdate();
  });

  window.addEventListener('load', flushQueue, { once: true });
  window.setTimeout(flushQueue, 1500);

  initSectionObserver();
  initFormCompletions();
  initSearchNoResults();
  initPromotionQualificationTracking();
  initMonsterCartTracking();

  window.JanelaBayAnalytics = {
    version: VERSION,
    events: debugEvents,
    publish: publish,
    flush: flushQueue,
    context: context
  };

  if (debugEnabled && contextNode) {
    contextNode.setAttribute('data-analytics-ready', VERSION);
    contextNode.setAttribute('data-analytics-events', JSON.stringify(debugEvents.slice(-30)));
  }
})();
